export default __webpack_public_path__ + "static/media/EARTH.60ecb554.png";